export default __webpack_public_path__ + "static/media/insta3.c982cb53.jpg";